export interface VisaFile {
  id: number;
  originalName: string;
  mimeType: string;
  size: number;
}
export interface VisaMessage {
  id: number;
  text: string;
  authorName: string;
  authorRole: "AGENT" | "ADMIN";
  createdAt: string;
  responseRequired: boolean;
  respondsToId: number | null;
  attachments: { fileId: number; file: VisaFile }[];
}
export interface VisaRequest {
  id: string;
  label: string;
  category: string;
  fulfilledDocumentId: number | null;
  fulfilledAt: string | null;
  suppliedByName?: string | null;
  requestedByName?: string | null;
  fulfilledDocument: VisaFile | null;
}
export interface VisaWorkspace {
  application: {
    id: number;
    reference: string;
    studentName: string;
    institution: string;
    status: string;
  };
  case: { id: string } | null;
  canHandle: boolean;
  viewerRole: "AGENT" | "ADMIN";
  progress: string;
  latestGuidance: VisaMessage | null;
  messageCount: number;
  pendingRequestCount: number;
  pendingResponseCount: number;
  pagination: {
    requestPage: number;
    responsePage: number;
    pageSize: number;
    requestCount: number;
    pendingResponseCount: number;
  };
  documentRequests: VisaRequest[];
  pendingResponses: Pick<
    VisaMessage,
    "id" | "text" | "authorName" | "createdAt"
  >[];
  messages: VisaMessage[];
  nextBeforeId: number | null;
}
export interface VisaApi {
  read(
    id: number,
    params: Record<string, number>,
    signal: AbortSignal,
  ): Promise<VisaWorkspace>;
  start(id: number): Promise<unknown>;
  send(id: number, body: FormData): Promise<unknown>;
  file(id: number, file: VisaFile): Promise<Blob>;
  supply?(
    id: number,
    request: VisaRequest,
    file: File,
    operation: string,
  ): Promise<unknown>;
}
export const visaApi = (
  api: any,
  file: (id: number, file: VisaFile) => Promise<Blob>,
  supply?: VisaApi["supply"],
): VisaApi => ({
  read: async (id, params, signal) =>
    (await api.get(`/visa-support/applications/${id}`, { params, signal })).data
      .data,
  start: async (id) =>
    (await api.post(`/visa-support/applications/${id}`)).data.data,
  send: async (id, body) =>
    (
      await api.post(`/visa-support/applications/${id}/messages`, body, {
        headers: { "Content-Type": "multipart/form-data" },
      })
    ).data.data,
  file,
  supply,
});
